import { getReportHeaders } from "@adapters/infrastructures/urlConfig/Reports/reportHeaders";
import urlConfig from "@adapters/infrastructures/urlConfig/Reports/reportsUrl";
import { taxResponseMapper } from "@domains/mapper/Reports/TaxMapper";
import { ClearTaxMapper } from "@domains/mapper/Reports/ClearTaxMapper";
import { getIsInIFrame } from "@domains/utils/tokenParser";
class TaxReportRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async getTaxReportData(requestData) {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(urlConfig.taxReportUrl);
        if (requestData === null || requestData === void 0 ? void 0 : requestData.accCode)
            url.searchParams.append("accountId", requestData === null || requestData === void 0 ? void 0 : requestData.accCode);
        else
            url.searchParams.append("accountId", accountCode);
        url.searchParams.append("fromDate", requestData.fromDate);
        url.searchParams.append("toDate", requestData.toDate);
        let taxReportData = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            signal: requestData.abortSignal,
            headers: getReportHeaders(accountCode),
        });
        return taxResponseMapper(taxReportData.data);
    }
    async clearTaxRedirect(req) {
        const url = new URL(urlConfig.clearTax);
        let clearTax = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
            avoidAuthToken: getIsInIFrame(),
        });
        return ClearTaxMapper(clearTax);
    }
}
export default TaxReportRepository;
